import { defineMessages } from 'react-intl';

export const i18n: {
	styleExpand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleExpand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendExpand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataTabTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	customizeTabTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aggregateData: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aggregateDataDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	orientationLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	verticalOrientation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	horizontalOrientation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	extensionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	insertChartTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chartOptionsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chartOptionsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chartTypeBar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chartTypeLine: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chartTypePie: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chartTypeField: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	heightField: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showLegend: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendPosition: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendAuto: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendTop: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendLeft: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendRight: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	legendBottom: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showPoints: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	smoothLines: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chartTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	yLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	xLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	xAxisSeriesName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	categoryName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	seriesNames: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultYLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultColumnName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataMissingTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dataMissingDetails: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	small: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	medium: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	large: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editSourceLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editSourceTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	styleExpand: {
		id: 'extension.charts.style',
		defaultMessage: 'Style',
		description:
			'Section heading that groups styling options in the Customize tab. Users can expand this section to access chart appearance and formatting settings.',
	},
	titleExpand: {
		id: 'extension.charts.title',
		defaultMessage: 'Title',
		description:
			'Section heading that groups title-related options in the Customize tab. Users can expand this section to edit the chart title and its appearance.',
	},
	legendExpand: {
		id: 'extension.charts.legend',
		defaultMessage: 'Legend',
		description:
			'Section heading that groups legend-related options in the Customize tab. Users can expand this section to configure legend display and positioning.',
	},
	dataTabTitle: {
		id: 'extension.charts.dataTab',
		defaultMessage: 'Data',
		description:
			'The title of data tab. It appears as a heading of the Data tab in the configuration panel.',
	},
	customizeTabTitle: {
		id: 'extension.charts.customizeTab',
		defaultMessage: 'Customize',
		description:
			'The title of customize tab. It appears as a heading of the Customize tab in the configuration panel.',
	},
	aggregateData: {
		id: 'extension.charts.aggregateData',
		defaultMessage: 'Aggregate data',
		description:
			'The title of Aggregate data toggle. It appears on a toggle when switched on will aggregate data for the categories with the same name.',
	},
	aggregateDataDescription: {
		id: 'extension.charts.aggregateDataDescription',
		defaultMessage:
			'Combine values into a single data point when multiple rows have the same value.',
		description:
			'The description of Aggregate data toggle. It appears on a toggle when switched on will aggregate data for the categories with the same name.',
	},
	orientationLabel: {
		id: 'extension.charts.orientation.label',
		defaultMessage: 'Orientation',
		description: 'Name of the dropdown that allows the user to change the orientation of a chart',
	},
	verticalOrientation: {
		id: 'extension.charts.vertical.orientation.label',
		defaultMessage: 'Vertical',
		description:
			'Name of the option that allows the user to change the orientation of a chart to vertical',
	},
	horizontalOrientation: {
		id: 'extension.charts.horizontal.orientation.label',
		defaultMessage: 'Horizontal',
		description:
			'Name of the option that allows the user to change the orientation of a chart to horizontal',
	},
	extensionTitle: {
		id: 'extension.charts.extensionTitle',
		defaultMessage: 'Chart',
		description: 'The title of this extension. It appears as a heading in the configuration panel.',
	},

	insertChartTooltip: {
		id: 'extension.charts.insert.tooltip',
		defaultMessage: 'Insert chart',
		description: 'Tooltip that appears while hovering a button that will insert a chart',
	},

	chartOptionsLabel: {
		id: 'extension.charts.options.label',
		defaultMessage: 'Chart options',
		description: 'Text button that lets you change settings for a chart',
	},

	chartOptionsTooltip: {
		id: 'extension.charts.options.tooltip',
		defaultMessage: 'Change chart options',
		description:
			'Tooltip that appears while hovering a button that lets you change settings for a chart',
	},

	chartTypeBar: {
		id: 'extension.charts.type.bar',
		defaultMessage: 'Bar',
		description:
			'Option in a dropdown menu that allows users to select a bar chart type for visualizing data. Displays data as vertical or horizontal bars.',
	},

	chartTypeLine: {
		id: 'extension.charts.type.line',
		defaultMessage: 'Line',
		description:
			'Option in a dropdown menu that allows users to select a line chart type for visualizing data. Displays data as connected points on a line.',
	},

	chartTypePie: {
		id: 'extension.charts.type.pie',
		defaultMessage: 'Pie',
		description:
			'Option in a dropdown menu that allows users to select a pie chart type for visualizing data. Displays data as slices of a circle.',
	},

	chartTypeField: {
		id: 'extension.charts.type.fieldDescription',
		defaultMessage: 'Chart type',
		description: 'Name for the dropdown that lets you choose the chart type',
	},

	heightField: {
		id: 'extension.charts.height',
		defaultMessage: 'Plot area height',
		description:
			'Label for a field that allows users to adjust the vertical size of the chart plot area. Located in the Customize tab configuration panel.',
	},

	showLegend: {
		id: 'extension.charts.legend.show',
		defaultMessage: 'Show legend',
		description: 'Toggle button that controls showing and hiding a chart legend',
	},
	legendPosition: {
		id: 'extension.charts.legend.position',
		defaultMessage: 'Legend Position',
		description: 'Name for the dropdown that lets you choose the legend position',
	},

	legendAuto: {
		id: 'extension.charts.legend.auto',
		defaultMessage: 'Auto',
		description: 'Place the legend in the best automatically given free space',
	},

	legendTop: {
		id: 'extension.charts.legend.top',
		defaultMessage: 'Top',
		description:
			'Option in a legend position dropdown that positions the chart legend above the plot area. Users select this to place the legend at the top of the chart.',
	},

	legendLeft: {
		id: 'extension.charts.legend.left',
		defaultMessage: 'Left',
		description:
			'Option in a legend position dropdown that positions the chart legend to the left side of the plot area. Users select this to place the legend on the left.',
	},

	legendRight: {
		id: 'extension.charts.legend.right',
		defaultMessage: 'Right',
		description:
			'Option in a legend position dropdown that positions the chart legend to the right side of the plot area. Users select this to place the legend on the right.',
	},

	legendBottom: {
		id: 'extension.charts.legend.bottom',
		defaultMessage: 'Bottom',
		description:
			'Option in a legend position dropdown that positions the chart legend below the plot area. Users select this to place the legend at the bottom of the chart.',
	},

	showPoints: {
		id: 'extension.charts.showPoints',
		defaultMessage: 'Show data points',
		description: 'Show the data points on the chart on top of the line',
	},

	smoothLines: {
		id: 'extension.charts.smoothLines',
		defaultMessage: 'Smooth lines',
		description:
			'Toggle button label that allows users to enable smooth curved lines instead of straight lines in line charts. Used in line chart configuration.',
	},

	chartTitle: {
		id: 'extension.charts.userTitle',
		defaultMessage: 'Title',
		description:
			'Label for an input field where users can enter or edit a custom title for their chart. Appears in the chart configuration panel.',
	},

	yLabel: {
		id: 'extension.charts.yLabel',
		defaultMessage: 'Y-axis label',
		description:
			'Input field label that allows users to enter descriptive text to display along the vertical Y-axis of the chart for labeling data values.',
	},

	xLabel: {
		id: 'extension.charts.xLabel',
		defaultMessage: 'X-axis label',
		description:
			'Input field label that allows users to enter descriptive text to display along the horizontal X-axis of the chart for labeling categories.',
	},

	xAxisSeriesName: {
		id: 'extension.charts.xAxis',
		defaultMessage: 'X-axis',
		description: 'Select field where users choose which column represents the X-axis',
	},

	categoryName: {
		id: 'extension.charts.category',
		defaultMessage: 'Category',
		description:
			'Select field where users choose which column represents the Category for a Pie Chart',
	},

	seriesNames: {
		id: 'extension.charts.seriesNames',
		defaultMessage: 'Data series',
		description: 'Multi-select field where users choose which data series to include in the chart',
	},

	defaultTitle: {
		id: 'extension.charts.defaultTitle',
		defaultMessage: 'Untitled chart',
		description:
			'Default placeholder title that is automatically assigned to a newly created chart before the user provides a custom title in the configuration panel.',
	},

	defaultYLabel: {
		id: 'extension.charts.defaultYLabel',
		defaultMessage: 'Untitled axis',
		description:
			'Default placeholder text for the Y-axis label that is automatically assigned to new charts. Users can edit this in the configuration panel to provide a descriptive axis label.',
	},

	defaultColumnName: {
		id: 'extension.charts.defaultColumnName',
		defaultMessage: 'Column {0}',
		description: 'Default name for a column if none is specified in the table',
	},

	dataMissingTitle: {
		id: 'extension.charts.dataMissing.title',
		defaultMessage: 'No data to display',
		description:
			'Heading shown as an error to the user when the source data and the chart become disconnected/unable to be found.',
	},

	dataMissingDetails: {
		id: 'extension.charts.dataMissing.details',
		defaultMessage: 'We can’t find this chart’s source table on the page.',
		description:
			'Additional help text shown to the user when the source data and the chart become disconnected/unable to be found.',
	},

	small: {
		id: 'extension.charts.height.small',
		defaultMessage: 'Shorter',
		description:
			'Option in a height dropdown that reduces the vertical size of the chart plot area. Users select this to make charts more compact on the page.',
	},

	medium: {
		id: 'extension.charts.height.medium',
		defaultMessage: 'Default',
		description:
			'Option in a height dropdown that sets the chart to a standard vertical size. This is the default selection for newly created charts.',
	},

	large: {
		id: 'extension.charts.height.large',
		defaultMessage: 'Taller',
		description:
			'Option in a height dropdown that increases the vertical size of the chart plot area. Users select this to make charts more prominent on the page.',
	},

	editSourceLabel: {
		id: 'extension.charts.editSource.label',
		defaultMessage: 'Edit source',
		description:
			'Button text that appears in the chart toolbar. Clicking this button allows users to jump to and edit the source table that provides data for the chart.',
	},

	editSourceTooltip: {
		id: 'extension.charts.editSource.tooltip',
		defaultMessage: 'Jump to the source table to edit values',
		description:
			'Tooltip text that appears when hovering over the edit source button. Explains that clicking the button will navigate to the source table for editing.',
	},
});
